import bottomBanner from "../assets/images/bottom-banner-web.png";
import union from "../assets/icons/union.svg";
import wave from "../assets/icons/wave.svg";

export default function AboutUs() {
  return (
    <section
      id="about"
      className="container relative w-full mx-auto bg-cover bg-center min-h-[500px] flex flex-col h-full md:mt-12"
      style={{ backgroundImage: `url(${bottomBanner})` }}
    >
      <div className="flex justify-start h-10 md:h-16">
        <h2 className="flex items-center bg-white h-full px-2 md:px-6 text-lg md:text-2xl font-normal text-black">
          ABOUT US
        </h2>
        <img src={union} alt="union" className="h-full w-auto" />
      </div>

      <div className="flex flex-col justify-between items-center flex-1 mx-auto p-4 md:py-12 md:px-6">
        <img src={wave} alt="wave" className="object-contain" />

        <div className="bg-club-background p-4">
          <p className="text-light-gray font-normal text-sm md:text-base leading-relaxed text-start">
            Club FM is a private FM radio station for the state of Kerala in
            India, operated by the Mathrubhumi in Kerala. Club FM, Kerala's No.1
            FM, has been delivering tons of fun to Malayalee audiences for 14
            years, living up to its popular tagline "Ton Kannakkinu Fun". Born
            from the house of Mathrubhumi in the year 2007 with its first
            station in Thrissur, Club FM soon expanded to Kannur, Trivandrum,
            Kochi, Dubai, Kozhikode and Alappuzha, capturing the hearts of
            millions through well-crafted shows, affable and vibrant RJs and
            unlimited music curated by experts in the field.
          </p>
        </div>
      </div>
    </section>
  );
}
